import React, { FC } from 'react';

interface IRetryPollingButtonProps {
  title: string;
  disabled?: boolean;
  onClick: () => void;
}

export const RetryPollingButton: FC<IRetryPollingButtonProps> = ({ title, disabled, onClick }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={` text-white font-bold rounded-xl p-2 ${
        disabled ? 'cursor-not-allowed bg-platinum' : 'cursor-pointer bg-orange-soda'
      }`}
    >
      {title}
    </button>
  );
};
